import React from "react";
import CrudTasasAdmin from "./CrudTasasAdmin";

const codigoPosnetOptions = [
    { value: "Debito", label: "Debito" },
    { value: "Credito", label: "Credito" },
];

const tipoCuotaOptions = [
    { value: "", label: "Sin tipo" },
    { value: "normal", label: "Normal" },
    { value: "bancarizada", label: "Bancarizada" },
];

const fields = [
    { key: "cuota", label: "Cuota", type: "text", required: true, defaultValue: "0" },
    { key: "codigoPosnet", label: "Codigo Posnet", type: "select", options: codigoPosnetOptions, required: true, defaultValue: "Debito" },
    { key: "tipoCuota", label: "Tipo cuota", type: "select", options: tipoCuotaOptions, defaultValue: "" },
    { key: "comision", label: "Comision", type: "text", defaultValue: "" },
    { key: "iva", label: "IVA", type: "text", defaultValue: "" },
    { key: "comisionMasIva", label: "Comision mas IVA", type: "text", defaultValue: "" },
    { key: "costoAnticipoZoco", label: "Costo anticipo Zoco", type: "text", defaultValue: "" },
    { key: "costoVisaCredito", label: "Costo Visa credito", type: "text", defaultValue: "" },
    { key: "costoAmericanExpressCredito", label: "Costo Amex credito", type: "text", defaultValue: "" },
    { key: "costoMastercardCredito", label: "Costo Mastercard credito", type: "text", defaultValue: "" },
    { key: "costoArgencardCredito", label: "Costo Argencard credito", type: "text", defaultValue: "" },
    { key: "costoCabalCredito", label: "Costo Cabal credito", type: "text", defaultValue: "" },
    { key: "costoNaranjaCredito", label: "Costo Naranja credito", type: "text", defaultValue: "" },
];

const TablaTasasZocoAdmin = () => {
    return (
        <CrudTasasAdmin
            endpointBase={process.env.REACT_APP_API_TASAS_ZOCO}
            entityLabelSingular="tasa Zoco"
            entityLabelPlural="Tasas Zoco"
            searchPlaceholder="Buscar por cuota, codigo posnet o porcentaje"
            fields={fields}
        />
    );
};

export default TablaTasasZocoAdmin;
